import { useState, type SyntheticEvent } from "react";

import { Box } from "ui/box";
import { Tab, Tabs } from "ui/tabs";
import { EmailConfiguration } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration";

import { PAGE_SX } from "containers/admin/clients/client/theme-configuration-page/theme-configuration.styles";
import {
  CONFIGURATION_TABS,
  type ConfigurationTab,
} from "containers/admin/clients/client/theme-configuration-page/configuration/configuration.constants";

export const Configuration = () => {
  const [activeTab, setActiveTab] = useState<ConfigurationTab>("email");

  const handleTabChange = (_event: SyntheticEvent, tab: ConfigurationTab) => setActiveTab(tab);

  return (
    <Box sx={PAGE_SX}>
      <Tabs appearance="sub-nav" value={activeTab} onChange={handleTabChange} aria-label="Configuration type">
        {CONFIGURATION_TABS.map(({ value, label }) => (
          <Tab key={value} value={value} label={label} />
        ))}
      </Tabs>
      {activeTab === "email" && <EmailConfiguration />}
    </Box>
  );
};
